import React from 'react'
import { render } from 'react-dom'
import uncaught from 'uncaught'
import StateStore from './state'
import { startRouter } from 'mobx-router'
import views from './routeconfig'
import { App } from './components/app'
// import DevTools from 'mobx-react-devtools'

uncaught.start()
uncaught.addListener(function (error) {
  console.log('Uncaught error or rejection: ', error.message)
})

// create the app state
const store = new StateStore(views)
store.initUser((err) => {
  if (err) {
    console.error(err)
  }
  startRouter(views, store)
  const mount = document.getElementById('app') // mountpoint
  render((
    <div>
      <App store={store} />
      {/* <DevTools /> */}
    </div>
  ), mount) // and final render
})
